import React from 'react';
import { Col, DatePicker, Row, Input } from 'antd';
import { func, object, string, bool, array } from 'prop-types';
import moment from 'moment';

import {
  filterOption,
  filteredUsers,
  getCurrentUserId,
  disabledPastDays,
  sortDataByAlphabet,
  isCurrentUserAssignable,
} from '../../../utils';

import { AssignButton } from '../../../components/ui-helpers';
import { SvgIcon } from '../../../components/svg-icon';

import {
  FormItem,
  SelectS,
  ButtonWithLoaderS,
  CancelButton,
  FieldWrapper,
  StyledOption,
} from '../styled-components';
import { FormS } from './styled-components';
import { ReactQuillWrapped } from '../../../components/react-quill';
import TaskPriority from '../../../components/task-item/task-priority';
import { TASK_PRIORITIES } from '../../../api/constants';

const TaskForm = ({
  form: { getFieldDecorator, setFieldsValue },
  requestAssignees,
  setSelectedUser,
  selectedUser,
  description,
  isLoading,
  onSubmit,
  onCancel,
  dueDate,
  users,
  title,
  taskPriority,
}) => (
  <FormS>
    <Row gutter={20}>
      <Col span={24}>
        <FormItem label="Title">
          {getFieldDecorator('title', {
            initialValue: title,
            rules: [
              {
                required: true,
                message: 'Please type task title',
              },
              {
                max: 200,
                message: 'Max length is 200 characters.',
              },
            ],
          })(<Input size="large" placeholder="Type task title" />)}
        </FormItem>
      </Col>

      <Col span={24}>
        <FormItem label="Description">
          {getFieldDecorator('description', {
            initialValue: description,
          })(<ReactQuillWrapped
            height="150px"
            withPaddings
            placeholder="Type task description"
            theme="snow"
            bounds="#description"
            scrollingContainer="#description"
          />)}
        </FormItem>
      </Col>

      <Col span={24}>
        <FormItem label="Priority">
          {getFieldDecorator('taskPriority', {
            initialValue: taskPriority,
          })(<SelectS
            size="large"
            getPopupContainer={triggerNode => triggerNode.parentNode}
          >
            {TASK_PRIORITIES.map(priority => (
              <StyledOption value={priority.value} key={priority.value}>
                <TaskPriority priority={priority} />
              </StyledOption>
            ))}
          </SelectS>)}
        </FormItem>
      </Col>

      <Col span={12}>
        <FieldWrapper>
          <AssignButton
            type="button"
            style={{ marginRight: '-7px' }}
            disabled={
              selectedUser === getCurrentUserId() ||
              !isCurrentUserAssignable(false, requestAssignees, users)
            }
            onClick={() => {
              setSelectedUser(getCurrentUserId());
              setFieldsValue({ assignedTo: getCurrentUserId() });
            }}
          >
            <SvgIcon type="plus" /> Assign me
          </AssignButton>
          <FormItem label="Assignee">
            {getFieldDecorator('assignedTo', {
              ...(selectedUser && { initialValue: selectedUser }),
              rules: [
                {
                  required: true,
                  message: 'This filed is required',
                },
              ],
            })(<SelectS
              showSearch
              size="large"
              showArrow={false}
              allowClear
              placeholder="Please, select assignees"
              defaultActiveFirstOption={false}
              onChange={setSelectedUser}
              filterOption={filterOption}
              getPopupContainer={triggerNode => triggerNode.parentNode}
            >
              {sortDataByAlphabet('fullName', filteredUsers(false, requestAssignees, users)).map(user => (
                <StyledOption key={user._id} value={user._id}>
                  {user.fullName}
                </StyledOption>
              ))}
            </SelectS>)}
          </FormItem>
        </FieldWrapper>
      </Col>

      <Col span={12}>
        <FormItem label="Set Deadline">
          {getFieldDecorator('dueDate', {
            ...(dueDate && { initialValue: moment(dueDate) }),
            rules: [
              {
                required: true,
                message: 'This filed is required',
              },
            ],
          })(<DatePicker
            format="DD-MM-YYYY"
            size="large"
            placeholder="DD-MM-YYYY"
            disabledDate={disabledPastDays}
            getCalendarContainer={triggerNode => triggerNode.parentNode}
          />)}
        </FormItem>
      </Col>
    </Row>

    <Row type="flex" justify="center">
      <CancelButton onClick={onCancel} htmlType="button">
        Cancel
      </CancelButton>

      <ButtonWithLoaderS
        {...{ isLoading }}
        disabled={isLoading}
        onClick={onSubmit}
        htmlType="submit"
      >
        Save
      </ButtonWithLoaderS>
    </Row>
  </FormS>
);

TaskForm.propTypes = {
  setSelectedUser: func.isRequired,
  isLoading: bool.isRequired,
  onCancel: func.isRequired,
  onSubmit: func.isRequired,
  users: array.isRequired,
  form: object.isRequired,
  requestAssignees: array,
  taskPriority: string,
  selectedUser: string,
  description: string,
  dueDate: string,
  title: string,
};

TaskForm.defaultProps = {
  taskPriority: 'NO_PRIORITY',
  requestAssignees: [],
  selectedUser: '',
  description: '',
  dueDate: '',
  title: '',
};

export { TaskForm };



// WEBPACK FOOTER //
// ./src/modals/add-meeting-notes-modal/task-form/component.js